import React from 'react'
import { Tooltip, Slider, Select, Button, Input } from 'antd'
import { InfoCircleFilled, ToolOutlined } from '@ant-design/icons'

const SettingsContent = ({ settings, updateSettings, handleAdvancedSettings, saveSettings }) => {
    return (
        <div className="settings-drawer-content">
            <div className="setting-group" style={{ marginBottom: 24, borderBottom: '1px solid #f0f0f0', paddingBottom: 16 }}>
                <Button
                    onClick={() => handleAdvancedSettings(settings.sceneId, settings.shotId)}
                    icon={<ToolOutlined />}
                    type="primary"
                    ghost
                    block
                    style={{ height: '40px', fontSize: '16px' }}
                >
                    Advanced Settings
                </Button>
            </div>


            <div className="setting-group">
                <label>Motion</label>
                <Select
                    value={settings.motion}
                    onChange={value => updateSettings('motion', value)}
                    style={{ width: '100%' }}
                >
                    <Select.Option value="Static">Static</Select.Option>
                    <Select.Option value="Track down">Track down</Select.Option>
                    <Select.Option value="Track up">Track up</Select.Option>
                    <Select.Option value="Pan left">Pan left</Select.Option>
                    <Select.Option value="Pan right">Pan right</Select.Option>
                    <Select.Option value="Tilt up">Tilt up</Select.Option>
                    <Select.Option value="Tilt down">Tilt down</Select.Option>
                    <Select.Option value="Dolly in">Dolly in</Select.Option>
                    <Select.Option value="Dolly out">Dolly out</Select.Option>
                </Select>
            </div>

            <div className="setting-group">
                <label>Scene Motion</label>
                <Select
                    value={settings.sceneMotion}
                    onChange={value => updateSettings('sceneMotion', value)}
                    style={{ width: '100%' }}
                >
                    <Select.Option value="Natural motion">
                        Natural motion
                    </Select.Option>
                    <Select.Option value="Extreme motion">
                        Extreme motion
                    </Select.Option>
                </Select>
            </div>


            <div className="setting-group">
                <label>Temperature (Creativity)
                    <Tooltip title="Temperature is a value between 0 and 1 that controls the creativity of the video. Lower values make the video more realistic and deterministic, while higher values increase randomness and creativity.">
                        <InfoCircleFilled style={{ marginLeft: 8, cursor: 'pointer' }} />
                    </Tooltip>
                </label>
                <Slider
                    value={settings.temperature || 0.7}
                    onChange={value => updateSettings('temperature', value)}
                    min={0.1}
                    max={1.0}
                    step={0.1}
                    marks={{
                        0.1: '0.1',
                        0.5: '0.5',
                        1.0: '1.0'
                    }}
                />
            </div>

            <Button
                type="primary"
                onClick={saveSettings}
                style={{ marginTop: 16 }}
            >
                Save Settings
            </Button>
        </div>
    );
};

export default SettingsContent